export enum ReminderActionType {
	DisplayNotification = 1,
	SendMail = 2,
}
